module.exports = __webpack_public_path__ + "static/media/mybb.327df6f0.svg";